{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Dodaj więcej obrazów"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Zatwierdź"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Wstecz"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Powrót do logowania"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Obciążyć rachunek pokoju"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Kup więcej"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Anuluj"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Zamknij"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Dokończ zakup"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Kontynuuj"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Karta kredytowa lub debetowa"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "GOTOWE"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Pobierz"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Edytuj zamówienie"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Wejdź"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Zapomniałem"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Rozumiem"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Dalej(strzałka w prawo)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Wstecz(strzałka w lewo)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Powiększanie/pomniejszanie"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Wyloguj się"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Zaloguj się"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Przeglądanie galerii"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Więcej obrazów"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Nowe zamówienie"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Przewodnik cenowy"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Drukuj"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Proces"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Zakup"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Odśwież"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Usuń"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Usuń wydruki"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Przejrzyj i kup"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Wybierz"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Wybrane rozmiary wydruków ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Wyślij link"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Wyślij linki"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Udostępnij"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Zostań"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Czytnik Stripe"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Zobacz galerię"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Zobacz Moją galerię"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Pokaż paragon"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Możesz dodać więcej obrazów bez dodatkowych kosztów"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Zastosuj"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Całkowita kwota zakupu wynosi "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Kup wszystkie zdjęcia za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " za wszystko"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Szczegóły koszyka"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Koszyk łącznie"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Kasa"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Kod z kuponu"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Karta kredytowa lub debetowa"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Obrazy cyfrowe"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Zdjęcie cyfrowe"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Zdjęcia cyfrowe"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Zdjęcie cyfrowe"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Zdjęcia cyfrowe"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Wydruk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Wydruki"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Kup więcej obrazów, aby uzyskać rabat"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Otrzymasz "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " bezpłatnie."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "Wysłaliśmy link do Twojej galerii na adres "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Wybierz obrazy do zakupu przed dokonaniem rozliczenia"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "na "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Otrzymaj "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " zdjęcie"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " zdjęcia"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Otrzymaj wszystkie zdjęcia za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Otrzymaj "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " zdjęć za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Przewodnik cenowy"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Informacje o cenach można znaleźć w Przewodniku cenowym"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Wydruk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Wydruki"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Zakup"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Zakupione"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Zakupy"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Przepraszamy, wystąpił problem, który uniemożliwił realizację płatności. Spróbuj ponownie i skontaktuj się z nami, jeśli problem będzie się powtarzał."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "Standardowa cena wynosi "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " za sztukę"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Dziękujemy za zakup!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Łącznie"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Wszystkie obrazy cyfrowe"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Wszystkie obrazy cyfrowe i wydruki"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Niezakupione"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Zobacz zdjęcia"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Kup "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " zdjęcie"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " zdjęcia"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " i otrzymaj "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " zniżki"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " zniżki "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " lub więcej"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "Korzystając z Capturelife wyrażasz zgodę na nasz "
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Wprowadź hasło i potwierdź je."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Potwierdzenie hasła"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Skontaktuj się z nami"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "E-mail lub telefon"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "Adres e-mail lub numer telefonu"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Wprowadź adres e-mail."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Wprowadź hasło."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Wprowadź prawidłowy adres e-mail lub numer telefonu."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Aby zresetować hasło, wprowadź swój adres e-mail lub numer telefonu"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Nie pamiętasz hasła?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Sklep z wydrukami"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "Wygeneruj kod QR"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Przepraszamy, ten link wygasł. Aby otrzymać kolejny link, wprowadź swój adres e-mail lub numer telefonu."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Logowanie..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Wróćmy do upamiętnienia tych momentów!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Ups, wygląda na to, że czegoś brakuje."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Moje dane osobowe"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Dodaj zdjęcia"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Dodaj"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Wstecz"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Pobierz"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Strona główna"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Wyloguj się"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Aktualności"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Sklep z wydrukami"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profil"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Odśwież"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Udostępnij"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Twoje hasło musi składać się z co najmniej "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " znaków."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Hasło"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "Hasło i potwierdzenie hasła nie są zgodne."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Zrób zrzut ekranu swojego kodu QR lub kliknij przycisk „Pobierz” poniżej"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Zresetuj hasło"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Resetowanie hasła..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Zaznacz wszystko"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Aby pobrać lub udostępnić obraz, dotknij i przytrzymaj obraz: wyświetlą się opcje udostępniania urządzenia."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Sklep internetowy"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Warunki użytkowania"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Wprowadź adres e-mail i hasło, których chcesz użyć."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Zaktualizuj hasło"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Zaktualizuj hasło"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Trwa aktualizowanie hasła..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Witamy z powrotem!"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Nie można zastosować kodu rabatowego. Całkowita kwota zakupu jest niższa niż wymagana kwota minimalna"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Nie znaleziono kodu rabatowego"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Wprowadź prawdziwy adres e-mail."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Wprowadź swój adres e-mail."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Wypełnij poniższe pola."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Nie znaleziono rezerwacji."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Brak zdjęć dla tego konta. Zeskanuj opaskę używaną w fotobudce"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Brak zdjęć dla tego konta. Skontaktuj się z fotografem lub osobą obsługującą"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Karta kredytowa lub debetowa"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "Adres e-mail"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Nazwisko"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Hasło"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "PIN"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Cena (w "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Numer pokoju"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Tajny kod"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Zaznacz wszystko"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Odblokuj wszystkie obrazy"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Wymagane zatwierdzenie"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Poproś o pomoc"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Zatwierdź zakup"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Wprowadź cenę tego zakupu."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Automatyczne wylogowanie nastąpi za "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " sekunda"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " sekundy"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Hej, jesteś tam jeszcze?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " zdjęcie cyfrowe"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " zdjęcia cyfrowes"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " wydruk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " wydruki"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Przejrzyj i kup"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Dotknij,"
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " aby usunąć obraz z koszyka. Dotknij opcji "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "UKOŃCZ ZAKUP,"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " aby kontynuować."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Dodaj obrazy do swojej galerii"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Wybierz obrazy do zakupu"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Dotknij obrazów, aby dodać je do swojej galerii. Dotknij opcji "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "WYŚWIETL MOJĄ GALERIĘ"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", aby wrócić do swojej galerii."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Dotknij obrazów, aby dodać je do zamówienia. Dotknij opcji "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "PRZEGLĄDAJ I KUP"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", aby kontynuować."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Wczytywanie obrazów..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Wybierz i kup"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Twoja galeria obrazów"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Wybierz i wydrukuj"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Twoja galeria obrazów"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Dotknij obrazu, aby wybrać go do zakupu. Stuknij "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", aby kontynuować."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Twoja galeria jest pusta. Dotknij opcji "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "WIĘCEJ OBRAZÓW"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " w prawym górnym rogu ekranu, aby przeglądać dostępne obrazy."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Dotknij ikony drukowania na zdjęciu, aby wybrać je do wydrukowania. Dotknij przycisku Drukuj, aby wydrukować wybrane obrazy"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Dotknij obrazu, aby wybrać go do zakupu. Dotknij dwukrotnie, aby zażądać wydruku. Stuknij "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", aby kontynuować."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Odblokowałeś wszystkie obrazy. Dotknij,"
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " aby usunąć z galerii."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Odblokowałeś wszystkie obrazy. Dotknij obrazu, aby zażądać wydruku. Dotknij,"
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " aby usunąć z galerii."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Dodaj wydruk"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Zakup cyfrowy"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Zakupiony wydruk"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Wybrany wydruk"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Usuń wydruk"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Wybierz wydruk"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Twoje obrazy"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Wybierz obrazy"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Twój wybór"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Uzyskaj dostęp do swoich obrazów"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Aby uzyskać dostęp do galerii, wprowadź swój numer pokoju, nazwisko i adres e-mail"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Witamy!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Aby kontynuować, wprowadź swój adres e-mail."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Zeskanuj opaskę, aby rozpocząć"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Obciążyć rachunek pokoju"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "Twój pokój zostanie obciążony na poniższą kwotę"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Dokończ zakup"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Twoje zamówienie obejmuje:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Wszystkie transakcje sprzedaży mają charakter ostateczny, a zwroty nie są możliwe."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Szczegóły zamówienia"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Dotknij obrazów po lewej stronie, aby dodać je do koszyka."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Twój koszyk jest pusty. Dotknij obrazów, aby dodać je do zamówienia."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Twój koszyk jest pusty. Dotknij opcji "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "DODAJ WIĘCEJ OBRAZÓW"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Zdjęcia otrzymasz na swój adres e-mail."
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Aby uzyskać wydruk, dotknij dwukrotnie obrazu."
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Dokończ zakup"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Jak chcesz sfinalizować zakup?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Przewodnik cenowy"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Kup więcej obrazów, aby uzyskać rabat"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "Standardowa cena wynosi "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " za zdjęcie"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Możesz dodać więcej obrazów bez dodatkowych kosztów"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Rozmiary wydruku"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Wybierz rozmiar wydruku i liczbę kopii"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Przetwarzanie płatności..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Oferowane rabaty:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Oferowane pakiety:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " za zdjęcie"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Cena standardowa:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Łącznie:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Dotknij obrazów, aby dodać je do zamówienia"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Dotknij obrazów, aby wybrać je do zakupu lub odznaczyć. Aby dodać więcej obrazów, dotknij WIĘCEJ"
    },
    {
      "children": [
        {
          "type": 0,
          "value": " OBRAZÓW."
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Czytnik nie jest podłączony"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Czytnik nie zdołał przetworzyć"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Czytnik w trybie gotowości..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Zakup ukończony"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "Wysłaliśmy link do Twojej galerii na adres "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Czy chcesz usunąć ten obraz z zamówienia? Musisz go ponownie znaleźć, dotykając opcji "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "DODAJ WIĘCEJ OBRAZÓW"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Pokój "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Pokoje "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Link został wysłany na adres "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Współczynnik proporcji"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Wybrane wydruki"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Moment"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Liczba"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Rozmiar wydruku"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Dokończ zakup"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Wprowadź informacje o płatności"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Witaj, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Witaj, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}